import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./css/appointment.css";
// import Select from 'react-select';
import { FaGlobe, FaSearch } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import Select, { components } from "react-select";
import { DateTime } from "luxon";
import TextField from "@mui/material/TextField";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

import mints30icon from "./img/icon/30mint.png";
import mints15icon from "./img/icon/15minnew.png";
import hour1Icon from "./img/icon/1hour.png"

import axiosInstance from "../utils/axiosInstance"; // Import the configured axios instance

const CustomControl = ({ children, ...props }) => (
  <components.Control {...props}>
    <FaSearch style={{ marginLeft: 10, marginRight: 5, color: "#888" }} />
    {children}
  </components.Control>
);
const AppointmentForm = () => {
  const [selectedMeetingType, setSelectedMeetingType] = useState("30_MIN");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const calendarRef = React.useRef(null);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [date, setDate] = useState(DateTime.now());
  const [showDropdown, setShowDropdown] = useState(true);
  const [step, setStep] = useState(1);
  const [show, setShow] = useState(false);
  const [meetingName, setMeetingName] = useState("30 Minute Online Meeting");
  const [menuOpen, setMenuOpen] = useState(false);
  const otpLength = 6; // Define the length of the OTP
  const [otp, setOtp] = useState(Array(otpLength).fill(""));
  const inputsRef = useRef([]);
  const [bookedTimes, setBookedTimes] = useState([]);
  const [error, setError] = useState("");
  const [sucess, setSucess] = useState("");
  const defaultAdminTimezone = "America/New_York"; // US Eastern
  const [selectedTimezone, setSelectedTimezone] =
    useState(defaultAdminTimezone);

  const [showConfirm, setShowConfirm] = useState(false);

  const today = DateTime.now();

  useEffect(() => {
    if (!date) return;
    const formattedDate = date.toFormat
      ? date.toFormat("yyyy-MM-dd")
      : date.toISOString().split("T")[0];

    // const dateStr = selectedDate.format("YYYY-MM-DD"); // AntD DatePicker uses moment

    axiosInstance
      .get("/api/appointments/booked-times", {
        params: { date: formattedDate },
      })
      .then((res) => setBookedTimes(res.data || []))
      .catch((err) => console.error(err));
  }, [date, selectedTimezone]);

  // Prevent close on outside click
  const handleShow = () => setShow(true);
  const handleCloseX = () => {
    setShowConfirm(true); // open confirmation popup i
  };

  const handleClose = () => {
    setShow(false);
    setFormData({
      name: "",
      companyName: "",
      email: "",
      phone: "",
      purpose: "",
      date: today.toFormat("yyyy-MM-dd"),
      time: "",
      timezone: defaultAdminTimezone, // default user timezone
      meetingType: "30_MIN",
    });
    setSelectedTime(null);
    setStep(1);
    setDate(DateTime.now());
    setOtp(Array(otpLength).fill(""));
    setError("");
    setSelectedTimezone(defaultAdminTimezone);
  };

  const handleNextStep = () => {
    setStep((prev) => prev + 1);
  };

  // Format date in readable way
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const disableDates = ({ date }) => {
    const today = new Date();
    const day = date.getDay();
    return date < today || day === 0 || day === 6; // past dates + weekends
  };

  const meetingTypes = [
    {
      value: "30_MIN",
      label: "30 Minute Online Meeting",
      duration: "30 MIN",
      icon: mints30icon,
      //  durationIcon: mints30icon,
      description: "Schedule Meeting with Tiara Team.",
    },
    {
      value: "60_MIN",
      label: "1 Hour Online Meeting",
      duration: "60 MIN",
      icon: hour1Icon,
      description: "Schedule Meeting with Tiara Team.",
    },
  ];

  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    email: "",
    phone: "",
    purpose: "",
    date: today.toFormat("yyyy-MM-dd"),
    time: "",
    timezone: defaultAdminTimezone, // default user timezone
    meetingType: "30_MIN",
  });

  const timezones = [
    { label: "US Eastern", value: "America/New_York" },
    { label: "US Central", value: "America/Chicago" },
    { label: "US Pacific", value: "America/Los_Angeles" },
    // { label: "India", value: "Asia/Kolkata" },
  ];

  // Date selection – keep JS Date for Luxon!
  const handleDateChange = (date) => {
    if (!date) return;
    setDate(date);
    let formattedDate;
    if (DateTime.isDateTime(date)) {
      // Luxon DateTime
      formattedDate = date.toFormat("yyyy-MM-dd");
    } else if (date instanceof Date) {
      // JS Date
      formattedDate = date.toISOString().split("T")[0];
    } else {
      console.error("Unknown date type:", date);
      return;
    }

    setFormData({ ...formData, date: formattedDate });
  };

  // Generate admin slots (fixed US Eastern)

  const generateAdminSlots = (date, meetingType) => {
    if (!date) return [];

    const slotMinutes = meetingType === "30_MIN" ? 30 : 60;

    // 1) Normalize input to a Luxon DateTime
    let dt;
    if (DateTime.isDateTime(date)) {
      dt = date;
    } else if (date instanceof Date) {
      dt = DateTime.fromJSDate(date);
    } else {
      console.error("generateAdminSlots: unsupported date:", date);
      return [];
    }

    // 2) Extract year/month/day (so we ignore time-of-day the user might have)
    const { year, month, day } = dt;

    // 3) Build start/end in admin timezone
    const start = DateTime.fromObject(
      { year, month, day, hour: 10, minute: 0, second: 0, millisecond: 0 },
      { zone: defaultAdminTimezone }
    );
    const end = DateTime.fromObject(
      { year, month, day, hour: 19, minute: 0, second: 0, millisecond: 0 },
      { zone: defaultAdminTimezone }
    );

    // 4) Generate slots — ensure the full meeting fits before adding the start
    const slots = [];
    let current = start;
    while (
      current.plus({ minutes: slotMinutes }).toMillis() <= end.toMillis()
    ) {
      slots.push(current);
      current = current.plus({ minutes: slotMinutes });
    }

    return slots; // array of Luxon DateTime (in admin timezone)
  };

  // Convert admin slots to selected timezone
  const convertSlotsToTimezone = (slots) =>
    slots.map((slot) => slot.setZone(selectedTimezone));

  // Effect: regenerate when date/type/timezone changes
  useEffect(() => {
    const adminSlots = generateAdminSlots(date, selectedMeetingType);
    const clientSlots = convertSlotsToTimezone(adminSlots);
    setAvailableSlots(clientSlots);
    setSelectedTime(null);
  }, [date, selectedMeetingType, selectedTimezone]);

  const handleMeetingTypeSelect = (type) => {
    setSelectedMeetingType(type);
    setFormData({ ...formData, meetingType: type });
  };

  const handleMeetingTypeName = (lable) => {
    setMeetingName(lable);
  };

  // const handleDateChange = (date) => {
  //   const formattedDate = date.toLocaleDateString("en-CA");
  //   setDate(formattedDate);
  //   setFormData({ ...formData, date: formattedDate });
  // };

  // const handleTimeSelect = (time) => {
  //   setSelectedTime(time);
  //   setFormData({ ...formData, time });
  //   // setShowForm(true);
  // };
  const bookingRef = useRef(null);

  const handleTimeSelect = (slot) => {
    setSelectedTime(slot);
    setFormData({
      ...formData,
      time: slot.toFormat("HH:mm"), // string for backend
    });

    // bookingRef.current?.scrollIntoView({
    //   behavior: "smooth",
    // });
  };

  const [touched, setTouched] = useState({
    name: false,
    companyName: false,
    email: false,
    phone: false,
    purpose: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched({ ...touched, [name]: true });
  };

  // Validation rules
  const validate = {
    name: (value) => {
      if (!value.trim()) return "Name is required";
      if (value.trim().length < 2) return "Name must be at least 2 characters";
      return "";
    },
    companyName: (value) => {
      if (!value.trim()) return "Company Name is required";
      if (value.trim().length < 2)
        return "Company Name must be at least 2 characters";
      return "";
    },
    email: (value) => {
      if (!value.trim()) return "Email is required";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) return "Invalid email format";
      return "";
    },
    phone: (value) => {
      if (!value.trim()) return "Phone is required";
      return "";
    },
    purpose: (value) => {
      if (!value.trim()) return "Purpose is required";
      if (value.trim().length < 5)
        return "Purpose must be at least 5 characters";
      return "";
    },
  };

  const getError = (field) => {
    const value = formData?.[field];
    if (value === undefined || value === null || value == "") return null; // no error if empty
    return validate[field](value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    handleNextStep();
    try {
      const otpString = otp.join("");
      const res = await axiosInstance.post(
        "/api/appointments/add", // relative to baseURL
        formData,
        { params: { otp: otpString } }
      );

      // alert("Appointment booked successfully!");
    } catch (err) {
      console.error(err);
      if (err.response.data.success == false) {
        setError("Invalid OTP, please try again");
      }
      hanldeGoBack2();
      // alert("Error booking appointment");
    } finally {
      setLoading(false); // hide loader
    }
  };

  const handleResendCode = async () => {
    setLoading(true);
    const res = await axiosInstance.post("/api/email/resend-otp", {
      email: formData.email,
    });

    setError("");
    setSucess("Verification code resent to " + formData.email);
    setOtp(Array(otpLength).fill("")); // reset OTP inputs
    setLoading(false);
  };
  const timezoneOptions = timezones.map((tz) => ({
    value: tz.value,
    label: tz.label,
  }));
  const handleGoBack = () => {
    setStep(1);
  };
  const hanldeGoBack2 = () => {
    setStep(2);
  };

  const handleChanges = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // only digits
    setSucess("");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    // onChanges && onChanges(newOtp.join(""));

    // move to next input
    if (index < otpLength - 1) {
      inputsRef.current[index + 1].focus();
    }
  };
  // Handle select change
  const handleSelectChange = (selectedOption) => {
    setSelectedTimezone(selectedOption.value);
    setFormData({ ...formData, timezone: selectedOption.value });
    setMenuOpen(false);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);

    setMenuOpen((prev) => !prev);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (newOtp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
        // onChanges && onChanges(newOtp.join(""));
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleEmailCode = async () => {
    setLoading(true);
    setError("");
    handleNextStep();
    const res = await axiosInstance.post("/api/email/verify-email", {
      email: formData.email,
    });

    setLoading(false);
  };

  return (
    <div className="bookings-container">
      <div class="card">
        <form
          onSubmit={handleSubmit}
        // style={{ maxWidth: "400px", margin: "auto" }}
        >
          <h2 style={{ textAlign: "center" }}>Schedule Meeting with Tiara Team</h2>
          <div className="meeting-type-section">
            <h2 className="section-title">Choose a meeting type</h2>
            <div className="meeting-type-options">
              {meetingTypes.map((type) => (
                <div
                  key={type.value}
                  className={`meeting-type-card ${selectedMeetingType === type.value ? "selected" : ""
                    }`}
                  onClick={() => {
                    handleMeetingTypeSelect(type.value);
                    handleMeetingTypeName(type.label);
                  }}
                >
                  <div className="meeting-type-content">
                    <div className="meeting-type-text">
                      <div className="meeting-type-label">{type.label}</div>
                      <div className="meeting-type-description">
                        {type.description}
                      </div>
                    </div>
                    <div className="meeting-type-image">
                      <img
                        src={type.icon}
                        alt="clock icon"
                        className="duration-side-image"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="meeting-date">
            <div className="form-group ">
              <div className="meeting-calendar">
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <DateCalendar
                    ref={calendarRef} // Ref for uncontrolled access
                    value={date}
                    onChange={handleDateChange} // Get selected date
                    disablePast // Example: disable past dates
                    // disable weekends
                    shouldDisableDate={(date) => {
                      const weekday = date.weekday; // Luxon: 1 = Monday ... 7 = Sunday
                      return weekday === 6 || weekday === 7; // disable Saturday & Sunday
                    }}
                  // sx={{
                  //   "& .MuiPickersDay-root.MuiPickersDay-today": {
                  //     border: "", // remove round border
                  //     backgroundColor: "transparent", // remove highlight
                  //   },
                  // }}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div className="time-slots">
              <div className="calendar-col-flex">
                <div className="searchdropdown">
                  <h4 className="time-slots-title">Available Time Slots</h4>
                  <div className="form-group searchtimedrop">
                    <div
                      className={`dropdown-container ${showDropdown ? "fade-in" : "fade-out"
                        }`}
                      style={{ width: "300px", maxWidth: "300px" }}
                    >
                      {showDropdown && (
                        <Select
                          name="timezone"
                          value={timezones.find(
                            (tz) => tz.value === formData.timezone
                          )}
                          onChange={handleSelectChange}
                          options={timezones}
                          menuIsOpen={menuOpen}
                          onMenuClose={() => setMenuOpen(false)}
                          onMenuOpen={() => setMenuOpen(true)}
                          placeholder="Select Timezone..."
                          components={{ Control: CustomControl }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="time-buttons">
                  {Array.isArray(availableSlots) &&
                    availableSlots.map((slot, index) => {
                      const isBooked = (bookedTimes || [])
                        .map((bt) =>
                          DateTime.fromISO(bt, { zone: "utc" }).setZone(
                            selectedTimezone
                          )
                        )
                        .some(
                          (bt) =>
                            bt.toFormat("HH:mm") === slot.toFormat("HH:mm")
                        );

                      return (
                        <button
                          type="button"
                          key={index}
                          className={`time-button 
          ${selectedTime?.toISO() === slot.toISO() ? "selected" : ""} 
          ${isBooked ? "booked" : ""}`}
                          onClick={() => !isBooked && handleTimeSelect(slot)}
                          disabled={isBooked}
                        >
                          {slot.toFormat("hh:mm a")}
                        </button>
                      );
                    })}
                </div>
                <div className="appoint-btn">
                  <Button
                    type="button"
                    variant="primary"
                    className="btnmesg appoint-btn-size"
                    onClick={handleShow}
                    disabled={!(meetingName && date && formData.time)}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="form-group">
            <Button
            // ref={bookingRef}
              type="button"
              variant="primary"
              className="btnmesg"
              onClick={handleShow}
              disabled={!(meetingName && date && formData.time)}
            >
              Next
            </Button>
          </div> */}

          <Modal
            show={show}
            onHide={handleCloseX}
            backdrop="static"
            keyboard={false}
            centered
            // style={{ maxWidth: '400px' , margin: '0 auto' }}
            size="md"
          >
            <Modal.Header closeButton className="border-0 pb-0">
              <Modal.Title className="w-100">
                {step >= 1 && step <= 3 && (
                  <div>
                    <h5 className="fw-bold">{meetingName}</h5>
                    <p
                      className={`text-muted mb-0 ${step === 1 ? "poppara" : ""
                        }`}
                    >
                      {formatDate(date)} {formData.time}
                      <br />
                      {formData.timezone}
                    </p>
                  </div>
                )}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-0">
              {step === 1 && (
                <div className="booking-form">
                  {/* Name */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Type your name here"
                      value={formData.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className={`form-control ${touched.name && getError("name") ? "is-invalid" : ""
                        }`}
                    />
                    {touched.name && getError("name") && (
                      <div className="invalid-feedback">{getError("name")}</div>
                    )}
                  </div>

                  {/* Company Name */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Company Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="companyName"
                      placeholder="Type your company name here"
                      value={formData.companyName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className={`form-control ${touched.name && getError("companyName")
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {touched.name && getError("companyName") && (
                      <div className="invalid-feedback">
                        {getError("companyName")}
                      </div>
                    )}
                  </div>

                  {/* Email */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Email <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Type your email here"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className={`form-control ${touched.email && getError("email") ? "is-invalid" : ""
                        }`}
                    />
                    {touched.email && getError("email") && (
                      <div className="invalid-feedback">
                        {getError("email")}
                      </div>
                    )}
                  </div>

                  {/* Phone */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Phone <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Type your phone here"
                      value={formData.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className={`form-control ${touched.phone && getError("phone") ? "is-invalid" : ""
                        }`}
                    />
                    {touched.phone && getError("phone") && (
                      <div className="invalid-feedback">
                        {getError("phone")}
                      </div>
                    )}
                  </div>

                  {/* Purpose */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Purpose <span className="text-danger">*</span>
                    </label>
                    <textarea
                      // type="text"
                      name="purpose"
                      placeholder="Enter the purpose of the meeting"
                      value={formData.purpose}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      className={`form-control ${touched.purpose && getError("purpose")
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {touched.purpose && getError("purpose") && (
                      <div className="invalid-feedback">
                        {getError("purpose")}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {step === 2 && (
                <div>
                  {loading ? (
                    <div className=" text-center">
                      <div className="mb-4 mt-4">
                        <h6 className="fw-bold mb-3">
                          Sending Verification Code...
                        </h6>
                        <p className="text-muted">
                          This may take a few moments.
                        </p>
                        <div className="loader"></div>
                      </div>
                    </div>
                  ) : (
                    <div className="verification-step">
                      <div className="text-center">
                        <div className="mb-4 mt-4">
                          <h6 className="fw-bold">
                            Verify your email: {formData.email}
                          </h6>
                          <p className="text-muted mb-0">
                            Please enter the verification code that has been
                            sent to your email address.
                          </p>
                        </div>
                      </div>

                      {/* <hr className="my-4" /> */}

                      <div className="mb-4">
                        <label className="form-label fw-semibold">
                          Email verification code
                        </label>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "1rem",
                          }}
                        >
                          {otp.map((digit, idx) => (
                            <input
                              key={idx}
                              type="text"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => handleChanges(e, idx)}
                              onKeyDown={(e) => handleKeyDown(e, idx)}
                              ref={(el) => (inputsRef.current[idx] = el)}
                              style={{
                                width: "2rem",
                                height: "2rem",
                                textAlign: "center",
                                fontSize: "1.5rem",
                                border: "none", // remove box
                                // borderBottom: "2px solid #000", // optional underline style
                                outline: "none",
                                background: "transparent",
                              }}
                              placeholder="-"
                            />
                          ))}
                        </div>
                      </div>

                      <div className="text-center">
                        {error && <p className="text-danger">{error}</p>}
                        {sucess && <p className="text-success">{sucess}</p>}
                      </div>

                      <hr className="my-4" />

                      <div className="d-flex justify-content-between align-items-center">
                        <button
                          variant="primary"
                          type="button"
                          className="btn"
                          style={{ padding: "5px" }}
                          onClick={handleResendCode}
                        >
                          Resend code
                        </button>
                        <button
                          variant="primary"
                          type="button"
                          className="btn"
                          style={{ padding: "5px" }}
                          onClick={handleGoBack}
                        >
                          Go back
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {step === 3 && (
                <div>
                  {loading ? (
                    <div className=" text-center">
                      <div className="mb-4 mt-4">
                        <h6 className="fw-bold mb-3">Booking...</h6>
                        <p className="text-muted">
                          This may take a few moments.
                        </p>
                        <div className="loader"></div>
                      </div>
                    </div>
                  ) : (
                    <div className="confirmation-step">
                      <div className="text-center">
                        <div className="mb-4 mt-4">
                          <h6 className="fw-bold mb-3">Booked</h6>
                          <FontAwesomeIcon
                            icon={faCircleCheck}
                            style={{ color: "#14bd8a" }}
                          />
                        </div>
                        <div className="text-center">
                          <p className="mb-3">
                            Please check your email ({formData.email}) for a
                            Zoom meeting invite from us.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer className="border-0">
              {step === 1 && (
                <Button
                  variant="primary"
                  onClick={() => {
                    handleEmailCode();
                  }}
                  disabled={
                    !(
                      formData.name &&
                      formData.email &&
                      formData.phone &&
                      formData.purpose
                    )
                  }
                >
                  Email verification code
                </Button>
              )}
              {/* <div className="loader"></div> */}

              {step === 2 && (
                <div>
                  {loading ? (
                    <div></div>
                  ) : (
                    <Button
                      className="btn"
                      variant="primary"
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                      style={{ padding: "5px" }}
                    >
                      Schedule Meeting
                    </Button>
                  )}
                </div>
              )}
              {step === 3 && (
                <div>
                  {loading ? (
                    <div></div>
                  ) : (
                    <div className="w-100 d-flex justify-content-between">
                      <Button variant="outline-secondary" onClick={handleClose}>
                        OK
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </Modal.Footer>
          </Modal>

          {/* Confirmation Modal */}
          <Modal
            show={showConfirm}
            onHide={() => setShowConfirm(false)}
            centered
            size="sm"
          // style={{ maxWidth: '400px' , margin: '0 auto', width:"100%" }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Cancel Booking</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              This meeting has not yet been scheduled and will be cancelled?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                No
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  handleClose();
                  setShowConfirm(false);
                }}
              >
                Yes, Cancel
              </Button>
            </Modal.Footer>
          </Modal>

          {/* <Button type="submit" variant="primary" className="w-100 btnmesg">
          Book Appointment
        </Button> */}
        </form>
      </div>
    </div>
  );
};

export default AppointmentForm;
